import { Instance } from 'mobx-state-tree';
import { CustomerSatisfactionDtoModelBase } from './CustomerSatisfactionDtoModel.base';

/* The TypeScript type of an instance of CustomerSatisfactionDtoModel */
export interface CustomerSatisfactionDtoModelType extends Instance<typeof CustomerSatisfactionDtoModel.Type> {}

/* A graphql query fragment builders for CustomerSatisfactionDtoModel */
export { selectFromCustomerSatisfactionDto, customerSatisfactionDtoModelPrimitives, CustomerSatisfactionDtoModelSelector } from './CustomerSatisfactionDtoModel.base';

/**
 * CustomerSatisfactionDtoModel
 */
export const CustomerSatisfactionDtoModel = CustomerSatisfactionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
